var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{staticClass:"w-full",attrs:{"success":"","small":""},on:{"click":_vm.handleReview}},[_vm._v(" Review ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }